import { cloneDeep } from 'lodash';

// Only replace translated content. Keep the new ticket's prices and relationships.
export function selectCopyLanguage(ticket, sourceTranslations, languageCode) {
    const nextTicket = cloneDeep(ticket);
    nextTicket.languageCode = languageCode;
    if (!languageCode || languageCode === ticket.languageCode) return nextTicket;

    const translation = (sourceTranslations || []).find(item => item.languageCode === languageCode);
    nextTicket.name = translation?.name ? `${translation.name} Copy` : '';
    nextTicket.description = translation?.description ?? '';
    nextTicket.extraInfos = cloneDeep(translation?.extraInfos ?? ticket.initExtraInfos());
    return nextTicket;
}
